import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-gradient-to-b from-white to-secondary/30" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-176">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-177">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-main leading-tight mb-6" data-id="element-178">
              {t.hero.title}
            </h1>

            <p className="text-lg sm:text-xl font-medium text-primary mb-6 flex flex-wrap gap-2 items-center" data-id="element-179">
              {t.hero.subtitle}
            </p>

            <p className="text-text-muted text-lg mb-8 max-w-lg leading-relaxed" data-id="element-180">
              {t.hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-181">
              <button onClick={() => window.location.href = 'https://tokoteta.id/auth/register'} className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary-hover text-white font-semibold px-8 py-3.5 rounded-full transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-182">
                {t.hero.registration}
                <ArrowRight size={18} data-id="element-183" />
              </button>
            </div>

            <div className="flex items-center gap-3" data-id="element-184">
              <div className="flex -space-x-3" data-id="element-185">
                <img src="https://i.pravatar.cc/100?img=1" alt="User" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-186" />
                <img src="https://i.pravatar.cc/100?img=2" alt="User" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-187" />
                <img src="https://i.pravatar.cc/100?img=3" alt="User" className="w-8 h-8 rounded-full border-2 border-white object-cover" data-id="element-188" />
              </div>
              <p className="text-xs font-semibold text-text-main" data-id="element-189">
                {t.hero.joinText}
              </p>
            </div>
          </motion.div>

          {/* Right Image - Shadow removed */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative lg:h-[600px] flex items-center justify-center" data-id="element-190">
            <img src="https://cdn.magicpatterns.com/uploads/q2ajKz8p7Hb7P5QVQ8ny3g/Section.png" alt="Tokoteta App Preview" className="w-full max-w-[500px] h-auto object-contain" data-id="element-191" />
          </motion.div>
        </div>
      </div>
    </section>;
}